document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slider-wrapper").forEach(slider => {
    const autoSlide = slider.dataset.autoSlide === "true";
    const delay = parseInt(slider.dataset.delay) || 3000;
    const nextBtn = slider.closest(".premium-slider").querySelector(".slider-btn.next");
    const prevBtn = slider.closest(".premium-slider").querySelector(".slider-btn.prev");

    // ── STEP 1: Clone items ──
    const originalItems = Array.from(slider.querySelectorAll(".slider-item"));
    const count = originalItems.length;

    originalItems.forEach(item => slider.appendChild(item.cloneNode(true)));
    [...originalItems].reverse().forEach(item => {
      slider.insertBefore(item.cloneNode(true), slider.firstChild);
    });

    // ── STEP 2: Item width ──
    function getItemWidth() {
      const item = slider.querySelector(".slider-item");
      const gap = parseInt(getComputedStyle(slider).gap) || 20;
      return item.offsetWidth + gap;
    }

    function getSetWidth() {
      return getItemWidth() * count;
    }

    // ── STEP 3: Jump to middle ──
    function initPosition() {
      slider.style.scrollBehavior = "auto";
      slider.scrollLeft = getSetWidth();
      slider.style.scrollBehavior = "";
    }
    initPosition();

    // ── STEP 4: Silent teleport ──
    function teleportIfNeeded() {
      const set = getSetWidth();
      const scroll = slider.scrollLeft;

      if (scroll >= set * 2) {
        slider.style.scrollBehavior = "auto";
        slider.scrollLeft = scroll - set;
        slider.style.scrollBehavior = "";
      } else if (scroll < set) {
        slider.style.scrollBehavior = "auto";
        slider.scrollLeft = scroll + set;
        slider.style.scrollBehavior = "";
      }
    }

    // ── STEP 5: Detect scroll stop ──
    let isScrolling = false;

    slider.addEventListener("scroll", () => {
      if (!isScrolling) {
        isScrolling = true;
        requestAnimationFrame(function check() {
          const before = slider.scrollLeft;
          requestAnimationFrame(function () {
            const after = slider.scrollLeft;
            if (before === after) {
              isScrolling = false;
              teleportIfNeeded();
            } else {
              requestAnimationFrame(check);
            }
          });
        });
      }
    });

    // ── STEP 6: Buttons ──
    nextBtn.addEventListener("click", () => {
      slider.scrollBy({ left: getItemWidth(), behavior: "smooth" });
    });

    prevBtn.addEventListener("click", () => {
      slider.scrollBy({ left: -getItemWidth(), behavior: "smooth" });
    });

    // ── STEP 7: Auto slide ──
    if (autoSlide) {
      let auto = setInterval(() => {
        slider.scrollBy({ left: getItemWidth(), behavior: "smooth" });
      }, delay);

      slider.addEventListener("mouseenter", () => clearInterval(auto));
      slider.addEventListener("mouseleave", () => {
        auto = setInterval(() => {
          slider.scrollBy({ left: getItemWidth(), behavior: "smooth" });
        }, delay);
      });
    }
  });
});